package com.hyperether.goodjob.scenes.components

import androidx.compose.material.Icon
import androidx.compose.material.LocalContentAlpha
import androidx.compose.material.LocalContentColor
import androidx.compose.material3.IconButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.baseline_arrow_drop_down_24
import org.jetbrains.compose.resources.painterResource

@Composable
fun TrailingDropdownIconButton(
    onClick: () -> Unit,
    tint: Color = LocalContentColor.current.copy(alpha = LocalContentAlpha.current)
) {
    IconButton(onClick = onClick) {
        Icon(
            painter = painterResource(Res.drawable.baseline_arrow_drop_down_24),
            contentDescription = "Dropdown",
            tint = tint
        )
    }
}